import { useCallback } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';

import { useConsent } from './consent-context';
import { ConsentSettings } from './consent-settings';

export function ConsentBanner() {
  const { t } = useTranslation('consent');
  const { consent, saveConsent, settingsOpen, openSettings } = useConsent();

  const handleAcceptAll = useCallback(() => {
    saveConsent({ analytics: true });
  }, [saveConsent]);

  const handleNecessaryOnly = useCallback(() => {
    saveConsent({ analytics: false });
  }, [saveConsent]);

  if (settingsOpen) {
    return <ConsentSettings />;
  }

  if (consent) {
    return null;
  }

  return (
    <aside className="consent-banner" aria-label={t('banner.title')}>
      <div className="consent-banner-copy">
        <h2>{t('banner.title')}</h2>
        <p>
          {t('banner.text')} <Link to={paths.privacy}>{t('banner.privacyLink')}</Link>
        </p>
      </div>
      <div className="consent-actions">
        <button type="button" className="btn btn-blue" onClick={handleAcceptAll}>
          {t('banner.acceptAll')}
        </button>
        <button type="button" className="btn btn-ghost" onClick={handleNecessaryOnly}>
          {t('banner.necessaryOnly')}
        </button>
        <button type="button" onClick={openSettings} className="btn btn-ghost">
          {t('banner.customize')}
        </button>
      </div>
    </aside>
  );
}
